<app-main-slider
  [translations]="translations"
  [initialSlides]="data?.slides"
  [disableAutoFetch]="true"
></app-main-slider>
@if (isHomeLiveSectionShown) {
  <app-live-horses
    [data]="data?.auction_items"
    [currentDateTime]="currentDateTime"
    [locale]="localeService.locale"
    [isLoading]="isLoading"
    [has_upcoming_auctions]="data?.has_upcoming_auctions"
    [displayType]="data?.display_type"
    [loggedIn]="loggedIn"
    [user_id]="user_id"
    [dir]="localeService.dir$ | async"
    (loadData)="getData(false)"
  ></app-live-horses>
}
<app-auctions-statistics
  [statistics]="data?.counts"
  [translations]="translations"
></app-auctions-statistics>
<!-- <app-auctions></app-auctions> -->
<!--
  International Auctions (BXS-3627 / F1.5). Partner sales sit in the commercial
  upper half of the page, above the corporate content, matching the mockup.
  It feeds itself from InternationalAuctionsService — no inputs, and no tie to
  the homepage bootstrap object — and renders nothing at all when the admin
  flag is off.
-->
<app-international-auctions-band></app-international-auctions-band>
<app-about-us
  [data]="data?.counts"
  [translations]="translations"
></app-about-us>
<app-how-process
  [isLoggedIn]="loggedIn"
  [translations]="translations"
></app-how-process>
<app-system-features [translations]="translations"></app-system-features>
<!-- <app-our-clients></app-our-clients>
<app-join-us></app-join-us> -->
<app-blogs
  [translations]="translations"
  [dir]="localeService.dir$ | async"
  [initialBlogs]="data?.blogs"
  [disableAutoFetch]="true"
></app-blogs>
<!-- <div
class="to-top"
(click)="scrollToTop()"
[ngClass]="{ 'show-scrollTop': windowScrolled }"
>
<mat-icon>keyboard_arrow_up</mat-icon>
</div>
-->
